export default __webpack_public_path__ + "static/media/clock-regular.0d4adac4.svg";